import { NEW_FAMILY_MEMBER_TAB_ID } from 'store/modules/subscriber/health-questionnaire/manageConditionModalDelegate';

export const getManageConditionFormId = (tabId: string): string =>
  tabId === NEW_FAMILY_MEMBER_TAB_ID ? 'manage-condition-new-family-member-form' : `manage-condition-form-${tabId}`;
